import {
    Component,
    EventEmitter,
    Inject,
    Input,
    Output,
    SimpleChanges,
    OnChanges,
} from "@angular/core";

import { AgecLink } from "@hermes/api-model-product";
import { LOCALE, WINDOW } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

import { RouterService } from "@hermes/utils-generic/services/router";

@Component({
    selector: "h-product-info-footer",
    templateUrl: "product-info-footer.component.html",
    styleUrls: ["./product-info-footer.component.scss"],
})
export class ProductInfoFooterComponent implements OnChanges {
    @Input()
    public productReference?: string;

    @Input() public isComposite: boolean = false;

    @Input() public agecLinks: AgecLink[] = [];

    @Input() public specificTermsOfProductUse: boolean = false;

    @Output()
    public customerServiceLinkClicked: EventEmitter<void> =
        new EventEmitter<void>();

    public shouldDisplayAgecRedirectionForSimpleProduct: boolean = false;

    constructor(
        @Inject(LOCALE) private locale: Locale,
        private routerService: RouterService,
        @Inject(WINDOW) private window: Window,
    ) {}

    public ngOnChanges({ isComposite, agecLinks }: SimpleChanges): void {
        if (isComposite || agecLinks) {
            this.shouldDisplayAgecRedirectionForSimpleProduct =
                !this.isComposite &&
                this.agecLinks?.length === 1 &&
                this.agecLinks[0].isAgec;
        }
    }

    public openTabAgecPage(productSku?: string): void {
        const host: string = location.origin;
        const url: string = `${host}${this.locale.urlPrefix}/environment/${
            productSku ?? this.productReference
        }/`;

        this.window.open(url, "_blank", "noopener,noreferrer");
    }

    public onCustomerServiceLinkClicked(event: Event): void {
        event.preventDefault();
        this.customerServiceLinkClicked.emit();
        this.routerService.spaRedirect("/contact-us/");
    }
}
